export default function({ route, store }) {
    let code = route.query.code || '';
 	return store.dispatch('activity/getActivityList', { code });
}